import { createSelector } from 'reselect';
import {
  getCategories,
  getParentCategories,
  getSelectedCategories,
} from './basicData';

const activeCategories = (categories, selected) => Object.keys(categories)
  .filter((id) => (-1 < selected.indexOf(parseInt(id, 10))))
  .map((id) => categories[id]);

// Takes in activeCategories
const activeParents = (categories, parents) => categories
  .reduce((acc, { parent }) => acc.concat(parent), [])
  // Lets dedupe
  .reduce((acc, val) => (-1 < acc.indexOf(val) ? acc : acc.concat(val)), [])
  // Lets grab parent elements then
  .reduce((acc, val) => ({ ...acc, [val]: parents[val] }), {});

const getActiveCategoriesViaParent = (parents, categories) =>
  Object.keys(parents).reduce((acc, id) => ({
    ...acc,
    [id]: {
      name: parents[id],
      children: categories.filter(({ parent }) => parent === parseInt(id, 10)),
    },
  }), {});

const activeCategoriesSelector = createSelector(
  [getCategories, getSelectedCategories],
  activeCategories
);

const activeParentsSelector = createSelector(
  [activeCategoriesSelector, getParentCategories],
  activeParents
);

export default createSelector(
  [activeParentsSelector, activeCategoriesSelector],
  getActiveCategoriesViaParent
);

export {
  activeCategories,
  activeParents,
  getActiveCategoriesViaParent,
};



// WEBPACK FOOTER //
// ./app/selectors/getActiveCategoriesViaParent.js